import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { MessageContext } from "../../../common/message";
import { POST, PUT } from "../../../utils/fetchUtil";
import CustomCancelElectionModal from "./customModals/CustomCancelElectionModal";

const VotingFooterButtons = ({
  electionState,
  setAddCandidatTableVisible,
  addCandidatTableVisible,
  disabled,
  dispatch,
  electionTypes,
}) => {
  const history = useHistory();
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const [cancelElectionModal, setCancelElectionModal] = useState(false);
  // const [voteBtnDisabled, setVoteBtnDisabled] = useState(false);
  const [updateInProgress, setUpdateInProgress] = useState(false);

  const goback = () => {
    message.toggle({
      title: "Napomena",
      content: "Jeste li sigurni da želite odustati?",
      yesLabel: t("modalMessage.yesLabel"),
      onYes: () => {
        message.toggle({});
        history.goBack();
      },
      onNo: () => message.toggle({}),
    });
  };

  const handleClickSpremi = () => {
    if (!addCandidatTableVisible) {
      if (
        electionState.electionType?.id > 0 &&
        electionState.dateOfAnnouncement &&
        electionState.location?.id > 0
      ) {
        POST(
          `/elections/create`,
          electionState,
          (response) => {
            if (response.errorMessage) {
              message.toggle({
                title: t("requests.reviewDocuments.action.save.error"),
                content: response.errorMessage,
                hideNo: true,
                yesLabel: t("modalMessage.okLabel"),
                onYes: () => {
                  message.toggle({});
                },
              });
            } else {
              dispatch({ type: "update", payload: { id: response.id } });
              dispatch({ type: "update", payload: { statusId: 1 } });
              dispatch({
                type: "update",
                payload: { generatedStatus: { id: 1, status: "U planiranju" } },
              });
              setAddCandidatTableVisible(true);
              message.toggle({
                title: "Izbori",
                content: t("Izbori su uspješno kreirani"),
                hideNo: true,
                yesLabel: t("modalMessage.okLabel"),
                onYes: () => {
                  message.toggle({});
                },
              });
            }
          },
          (error) => {
            message.toggle({
              title: t("requests.reviewDocuments.action.save.error"),
              content: error,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        );
      } else {
        message.toggle({
          title: "Napomena",
          content: "Molimo unesite sve označene podatke.",
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    }
    // 2.korak -> Ponovo spremanje svih podataka
    else {
      PUT(
        `/elections/${electionState.id}`,
        electionState,
        (response) => {
          if (response.errorMessage) {
            message.toggle({
              title: t("requests.reviewDocuments.action.save.error"),
              content: response.errorMessage,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          } else {
            message.toggle({
              title: t("Izbori"),
              content: t("Izbori su uspješno spremljeni"),
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
    }
  };

  const handleClickOtkazi = () => {
    setCancelElectionModal(true);
  };

  const handleClickZakljucaj = () => {
    let areDatesValid = true;
    let isNumberOfChoicesValid = true;
    let dateErrorMsgContent = "";

    if (
      electionState.dateOfAnnouncement &&
      electionState.dateTimeVotingStart &&
      electionState.dateTimeVotingEnd
    ) {
      let dateOfAnnouncement = new Date(electionState.dateOfAnnouncement);
      let dateTimeVotingStart = new Date(electionState.dateTimeVotingStart);
      let dateTimeVotingEnd = new Date(electionState.dateTimeVotingEnd);

      //Date validation
      if (dateOfAnnouncement.getTime() >= dateTimeVotingStart.getTime()) {
        areDatesValid = false;
        dateErrorMsgContent = "Datum raspisivanja ne može biti noviji od datuma početka glasovanja";
      }
      if (dateOfAnnouncement.getTime() >= dateTimeVotingEnd.getTime()) {
        areDatesValid = false;
        dateErrorMsgContent =
          "Datum raspisivanja ne može biti noviji od datuma završetka glasovanja";
      }
      if (dateTimeVotingStart.getTime() >= dateTimeVotingEnd.getTime()) {
        areDatesValid = false;
        dateErrorMsgContent = "Vremenski period glasovanja nije ispravan.";
      }
    }
    if (electionState.dateTimeVotingEnd === null) {
      areDatesValid = false;
      dateErrorMsgContent = "Nije unesen datum završetka glasovanja.";
    }
    if (electionState.dateTimeVotingStart === null) {
      areDatesValid = false;
      dateErrorMsgContent = "Nije unesen datum početka glasovanja.";
    }
    if (electionState.dateTimeVotingStart === null && electionState.dateTimeVotingEnd === null) {
      areDatesValid = false;
      dateErrorMsgContent = "Nisu uneseni datumi početka i završetka glasovanja. ";
    }

    const elType = electionTypes.find((el) => {
      return el.id === electionState.electionType.id;
    });

    if (elType) {
      const isMultipleChoice = elType.multipleChoice;
      if (electionState.numberOfChoices === "" || electionState.numberOfChoices < 1) {
        isNumberOfChoicesValid = false;
      }
      if (!isMultipleChoice && electionState.numberOfChoices > 1) {
        isNumberOfChoicesValid = false;
      }
    }

    if (areDatesValid && isNumberOfChoicesValid) {
      message.toggle({
        title: "Napomena",
        content:
          "Zaključavanjem izbora onemogućeno je daljnje uređivanje i dodavanje podataka. Jeste li sigurni da želite zaključati izbore?",
        yesLabel: t("modalMessage.yesLabel"),
        onYes: () => {
          setUpdateInProgress(true);
          dispatch({ type: "update", payload: { statusId: 2 } });
          message.toggle({});
        },
        onNo: () => message.toggle({}),
      });
    } else if (!isNumberOfChoicesValid) {
      message.toggle({
        title: "Napomena",
        content: "Maksimalan broj mogućih izbora kandidata za ovu vrstu izbora je 1",
        hideNo: true,
        yesLabel: t("modalMessage.okLabel"),
        onYes: () => {
          message.toggle({});
        },
      });
    } else {
      message.toggle({
        title: "Napomena",
        content: dateErrorMsgContent,
        hideNo: true,
        yesLabel: t("modalMessage.okLabel"),
        onYes: () => {
          message.toggle({});
        },
      });
    }
  };

  // PUT za zaključavanje izbora, nalazi se u useEffect jer se inace state prekasno napuni novim podacima
  useEffect(() => {
    if (electionState.statusId === 2 && updateInProgress) {
      PUT(
        `/elections/${electionState.id}`,
        electionState,
        (response) => {
          if (response.errorMessage) {
            message.toggle({
              title: t("requests.reviewDocuments.action.save.error"),
              content: response.errorMessage,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          } else {
            message.toggle({
              title: t("Napomena"),
              content: t("Izbori su zaključani"),
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
                history.goBack();
              },
            });
          }
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
      setUpdateInProgress(false);
    }
  }, [electionState.statusId, updateInProgress]);

  return (
    <>
      <CustomCancelElectionModal
        setCancelElectionModal={setCancelElectionModal}
        active={cancelElectionModal}
        electionState={electionState}
        dispatch={dispatch}
      />
      <div className="is-flex is-align-items-center is-justify-content-center is-size-4">
        <button onClick={goback} className="button is-danger is-outlined ">
          Odustani
        </button>
        {addCandidatTableVisible && electionState.generatedStatus?.id < 3 ? (
          <button className={"button is-outlined ml-4"} onClick={handleClickOtkazi}>
            Otkaži izbore
          </button>
        ) : null}
        {electionState.candidates?.length > 0 && electionState.generatedStatus?.id == 1 ? (
          <button className={"button is-outlined ml-4"} onClick={handleClickZakljucaj}>
            Zaključaj
          </button>
        ) : null}
        {!disabled ? (
          <button
            type="submit"
            className={true ? "button is-success is-outlined ml-4" : "button is-outlined ml-4"}
            onClick={handleClickSpremi}
            // disabled={voteBtnDisabled}
          >
            Spremi
          </button>
        ) : null}
      </div>
    </>
  );
};

export default VotingFooterButtons;
